import { QueryFunctionContext } from '@tanstack/react-query';
import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import {
  AUTOCOMPLETE_PAGE_SIZE,
  OptionsPage,
  OptionType,
  Page,
} from '../../common/queryClient';
import { UserUrl } from './UserUrl';
import type { UserSearchResultType } from '../schema';
import { useInfiniteSearchQuery } from '../../common/queryClient/useInfiniteSearchQuery';

export interface SearchUsersQueryParams {
  page?: number;
  searchText?: string;
  size?: number;
}

export const searchUsers = async (
  params: SearchUsersQueryParams
): Promise<Page<UserSearchResultType>> =>
  apiClient
    .get<Page<UserSearchResultType>>(expand(UserUrl.SEARCH_EXISTING, params))
    .then((response) => response.data);

const searchUserOptions = async ({
  meta,
  pageParam,
}: QueryFunctionContext<any, number>) => {
  const page = pageParam ?? 0;
  const result = await searchUsers({
    searchText: (meta?.searchText ?? '') as string,
    page,
    size: AUTOCOMPLETE_PAGE_SIZE,
  });

  const content: OptionType[] = result.content.map((item) => {
    return {
      value: item.id,
      label: item.username,
    };
  });
  return {
    content,
    last: result.last,
    number: result.number,
  } as OptionsPage;
};

export function useInfiniteSearchUsersQuery(term: string) {
  return useInfiniteSearchQuery(
    ['search-users-autocomplete'],
    searchUserOptions,
    term
  );
}
